import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import * as queryString from 'query-string'
import { initReactI18next } from 'react-i18next'

import cookie, { setLanguageCookies } from 'lib/cookie'
import { defaultLang, isDev, supportLangs } from '../config'

const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'customLanguageDetector',
  lookup: () => {
    const _supportLangs = supportLangs.map((l) => l.toLowerCase())
    const _defaultLang = defaultLang ?? 'en' // Hard coded fallback.

    let locale

    // keep url locale if found force locale flag in querystring
    const forceLocale = queryString.parse(location.search).force_locale
    if (
      forceLocale &&
      ['1', 'true'].includes(forceLocale.toString().toLowerCase())
    ) {
      const pathLocale = (window?.location?.pathname ?? '').split('/')
      if (pathLocale[0] === '') pathLocale.shift()

      locale = _supportLangs.includes(pathLocale[0]?.toLowerCase?.())
        ? pathLocale[0]
        : _defaultLang
    } else {
      // ignore locale in path, auto set language by these priority
      // - last displayed language on all xxx.yay.space web
      // - last displayed language on that web
      // - system language
      // - default language of each web

      // to fix wrong cookie domain set to some users
      if (cookie.oldAppDomainLocale.get()) cookie.oldAppDomainLocale.remove()

      // get last language dropdown selected value by user
      const domainLocale = cookie.appDomainLocale.get()
      const subDomainLocale = cookie.appLocale.get()

      // get system languages
      const windowLocales = window?.navigator?.languages

      const localeOveride: Record<string, string> = {
        'zh-TW': 'zh-HK', // Chinese Taiwan (Traditional) to be Chinese Hongkong
        zh: 'zh-CN', // Chinese to be Chinese (Simplified)
      }

      // Get first available locale.
      locale =
        (
          [domainLocale, subDomainLocale, ...windowLocales].filter(
            Boolean
          ) as string[]
        )
          .map((l) => localeOveride[l] || l)
          .find((l) => _supportLangs.includes(l.toLowerCase())) ?? _defaultLang
    }

    // set to cookies
    setLanguageCookies(locale)

    return locale
  },
})

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    backend: {
      queryStringParams: { v: window.gon.version },
    },
    fallbackLng: defaultLang,
    debug: isDev,
    supportedLngs: supportLangs,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    returnEmptyString: false,
    detection: {
      order: ['customLanguageDetector'],
    },
    parseMissingKeyHandler: () => ' ',
  })

export default i18n

export const LANGUAGE_MAPPER = {
  en: 'English (US)',
  id: 'Bahasa Indonesia',
  ja: '日本語',
  th: 'ภาษาไทย',
  ko: '한국어',
  'zh-CN': '简体中文',
  'zh-HK': '繁體中文',
}
